import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../constants';
import request from '../../components/Utils/httpHelper';
import { ACTIVITY_LOG_EXTRACT_DOWNLOAD , activityLogExtractDownloadResponse} from './action';
import { CORE_API } from '../../config';

export function* activityLogExtractDownloadRequest(action){
    let requestURL = `${CORE_API}/activity/extract`;

    try {
        const data = yield call(request, requestURL, { method: 'POST', data: action.data, headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(activityLogExtractDownloadResponse({ data : data.data , status : "SUCCESS"}));
    }
    catch (err) {
        yield put(activityLogExtractDownloadResponse( { ...err.response , status : "FAILURE"}))
    }
}
 
export function* activityLogExtractDownload() {
    yield takeLatest(ACTIVITY_LOG_EXTRACT_DOWNLOAD, activityLogExtractDownloadRequest);
}